import api from '../api/axios';

export const habitosService = {
  getHabitos: async () => {
    const { data } = await api.get('/habits');
    return Array.isArray(data) ? data.map(h => ({
      ...h,
      registros: typeof h.registros === 'string' ? JSON.parse(h.registros) : h.registros
    })) : [];
  },

  crearHabito: async (datos) => {
    const { data } = await api.post('/habits', { ...datos, registros: '[]' });
    return data;
  },

  actualizarHabito: async ({ id, datos }) => {
    const { data } = await api.put(`/habits/${id}`, datos);
    return data;
  },

  eliminarHabito: async (id) => {
    const { data } = await api.delete(`/habits/${id}`);
    return data;
  },
};
